import type { SourceDetailResponse } from "@/types/sources.ts";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http.ts";

/**
 * Resolve a source ent id to its render descriptor via `GET /a/sources/:id`.
 *
 * The endpoint returns the subtype plus the fully-hydrated detail for the two
 * renderable subtypes, so the canvas host mounts the right renderer and hands it
 * the detail directly — no second request keyed by the same id.
 */
export const useSource = (id: string | undefined) => {
  return useQuery(
    queryOptions({
      queryKey: ["source", id] as const,
      queryFn: id
        ? async ({ signal }) => {
            const { data } = await api.get<SourceDetailResponse>(`/api/a/sources/${id}`, {
              signal,
            });
            return data;
          }
        : skipToken,
      staleTime: 60_000,
    }),
  );
};
